<template>
    <div>
        <page-header title="Bulk Move Profiles"/>
        <app-card hide-header>

            <div class="pa-4" >
                <div style="display: flex; align-items: center" class="pb-4">
                    <div style="flex: 1; display: flex; align-items: center">
                        <div>
                            Move profiles from
                        </div>
                        <div class="pl-2 pr-2" style="transform: translateY(3px)">
                            <AppSelect
                                placeholder="Select Group"
                                :items="fromGroups"
                                item-value="id"
                                item-text="name"
                                :outlined="false"
                                v-model="fromGroupId"
                            />
                        </div>
                        <div>
                            to
                        </div>
                        <div class="pl-2 pr-2" style="transform: translateY(3px)">
                            <AppSelect
                                placeholder="Select Group"
                                :items="groups"
                                item-value="id"
                                item-text="name"
                                :outlined="false"
                                v-model="toGroupId"
                            />
                        </div>
                    </div>
                    
                    
                    <AppBtn 
                        v-if="groupsSelected" 
                        :disabled="selectedProfiles.length === 0"
                        @click="confirmMoveDialog = true"
                    >Move Selected Profiles</AppBtn>
                </div>
                <div v-if="toGroupId && fromGroupId && toGroupId === fromGroupId" style="color: var(--v-error-base)">
                    Please select two different groups
                </div>
                <div style="display: flex" v-if="groupsSelected">
                    <div  style="flex: 1" class="pr-4">
                        <AppTextField v-model="tableSettings.searchString"
                                      placeholder="Filter Profiles by Name"
                                      @input="updateSearchString"
                                      label=""
                                      prepend-inner-icon="mdi-magnify"
                        />
                    </div>
                    <div>
                        <AppSelect
                            :items="graduationYearOptions"
                            v-model="tableSettings.graduationSearchString"
                            @update:modelValue="updateOptions"
                            label=""
                            itemText="label"
                            itemValue="value"
                            placeholder="Select Graduation Year"
                        />
                    </div>
                </div>
            </div>
            
            <div v-show="groupsSelected">
                <v-data-table-server
                    :headers="headers"
                    :items="profiles"
                    :items-per-page="tableSettings.rowsPerPage"
                    v-model:options="options"
                    v-model:sort-by="sortBy"
                    :items-length="totalItems"
                    :loading="loading"
                    :page="tableSettings.pageNumber"
                    class="profiles-table"
                    id="profiles-table"
                    @update:options="updateOptions"
                    :search="tableSettings.searchString"
                    show-select
                    v-model="selectedProfiles"

                >

                    <template #no-data>
                        <div style="display: flex; justify-content: center">There are no profiles that match your search</div>
                    </template>


                </v-data-table-server>
            </div>



        </app-card>
        <app-confirm-dialog 
            :open="confirmMoveDialog"
            :title="confirmDialogTitle"
            submit-button-title="Move Profiles"
            @confirm="onMoveProfiles"
            @close="confirmMoveDialog = false"
            :loading="movingProfiles"
        >
            <div>
                <v-checkbox
                    v-model="removeFromOldGroup"
                    color="secondary"
                    hide-details
                    density="compact"
                >
                    <template #label>
                        <span v-if="fromGroupId > 0">Remove these profiles from the group "{{fromGroupName}}"?</span>
                        <span v-if="fromGroupId == -1">Remove these profiles from all groups?</span>
                    </template>
                </v-checkbox>
            </div>
        </app-confirm-dialog>
    </div>
    
</template>

<script>
import moment from 'moment'
import paginatedProfilesMixin from "@/mixins/paginatedProfilesMixin";
import {bulkMove, bulkMoveRequest, getGroups} from "@/services/groups.service";
import {SET_SNACKBAR} from "@/store/mutation-types";
import {isAdminOrgAccessType} from "@/js/shared/helper";

export default {
    name: "BulkMove",
    props: {

    },
    components: {

    },
    mixins: [paginatedProfilesMixin],
    data () {
        return {
            confirmMoveDialog: false,
            removeFromOldGroup: false,
            movingProfiles: false,
            selectedProfiles:[],
            groups: [],
            loadingGroups: false,
            fromGroupId: this.$route.params.groupId ? parseInt(this.$route.params.groupId) : null,
            toGroupId: null,
            headers: [
                {
                    title: 'Id',
                    align: 'start',
                    sortable: false,
                    key: 'id',
                },
                { title: 'Full Name', key: 'fullName', sortable: false },
                { title: 'Graduation Year', key: 'graduationYear' },
                { title: 'Last Test Date', key: 'lastTestDate' },
            ]
        }
    },
    mounted() {
        this.tableSettings.skipAverages = true;

        this.getGroups();
        
        if (this.fromGroupId){
            this.onFromGroupSet();
        }
    },
    watch: {
        fromGroupId() {
            this.onFromGroupSet();
        }
    },
    computed: {
        fromGroupName() {
            if (!this.fromGroupId || this.groups.length === 0)
                return null
            
            if (this.fromGroupId === -1)
                return "All Profiles"
            
            let group = this.groups.find(group => group.id === this.fromGroupId);
            return group.name
        },
        groupsSelected() {
            return this.fromGroupId && this.toGroupId && (this.fromGroupId !== this.toGroupId)
        },
        graduationYearOptions() {
            let response = ['']
            let year = moment().add(10, 'years').year();
            for (let i = 0; i < 15; i++) {
                response.push({
                    value: (year - i).toString(),
                    label: (year - i).toString()
                })
            }
            return response
        },
        allGroupIds() {
            return this.groups.map(g => g.id)
        },
        confirmDialogTitle(){
            if (this.selectedProfiles.length == 1)
                return 'Confirm Bulk Move ('+ this.selectedProfiles.length + ' Profile)';
            else
                return 'Confirm Bulk Move ('+ this.selectedProfiles.length + ' Profiles)';
        },
        fromGroups(){
            let response = [...this.groups];
            if (this.$store.getters.isOrgAdmin || this.$store.getters.isSuperAdmin)
                response.push({id: -1, name: "All Profiles"})
            return response;
        }
    },
    
    methods: {
        async getGroups() {
            const response = await getGroups();
            if (!response.isSuccess) {
                return
            }
            this.groups = response.groups
            // this.groups = []
            this.loadingGroups = false;
        },
        async onFromGroupSet() {
            if (this.fromGroupId == -1) {
                this.tableSettings.groupIds = this.allGroupIds;
            }
            else{
                this.tableSettings.groupIds = [this.fromGroupId];
            }
            
            await this.updateOptions();
        },
        async onMoveProfiles() {
            this.movingProfiles = true
            let request = {...bulkMoveRequest}
            // Vuetify 3 v-data-table v-model returns item keys (IDs), not objects
            request.profileIds = this.selectedProfiles.map(profile => typeof profile === 'object' ? profile.id : profile);
            request.oldGroupId = this.fromGroupId;
            request.newGroupId = this.toGroupId;
            request.removeFromOldGroup = this.removeFromOldGroup;

            let response = await bulkMove(request);
            this.movingProfiles = false

            if (!response.isSuccess) {
                this.$store.commit(SET_SNACKBAR, {
                    text: 'There was an error moving the profiles.',
                    color: 'error',
                    open: true
                });
                return
            }

            this.$store.commit(SET_SNACKBAR, {
                text: 'Successfully moved profiles.',
                color: 'success',
                open: true
            });

            this.confirmMoveDialog = false
            this.selectedProfiles = [];
            await this.onFromGroupSet();
        }
    }



}
</script>

<style scoped>
.profiles-table {
    /*color: var(--v-text-base)*/
}

input:focus,
select:focus,
textarea:focus,
button:focus {
    outline: none;
}

input {
    /*height: 40px*/
    width: 50%;
    /*height: 100%*/
}

.table-row:hover {
    background-color: var(--v-accent-base)!important;
    cursor: pointer
}
.table-row {
    background-color: white;
}

.search-input-area {
    border-radius: 15px;
    /*background-color: grey;*/
    height: 0px

}

.no-data {
    color: var(--v-text-base);
    margin: 20px
}

</style>